module.exports = __webpack_public_path__ + "img/78.3.TP.ce0de715.png";